export const warningMessage = (features: any[], theme: string, activeTool: string) => {
  const featureMatch = features.some(
    (feature) => feature.properties && feature.properties.Theme === theme
  );
  return activeTool === "cabinet"
    ? featureMatch
      ? "You have drawn your outline over an existing premises. If the property shown has been demolished/will be demolished, please continue."
      : "A connection may not be possible to this location. Are you sure you want to continue?"
    : "The meter point has been placed within an existing building, an automatic quote may not be available. Are you sure you want to continue?";
};
